export default __webpack_public_path__ + "static/media/40t.71cb1179.jpg";